import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ClipboardList, Wand2, CheckCircle2 } from "lucide-react";

export function OrdersManager({ onBuild, refreshKey }) {
  const [orders, setOrders] = useState([]);

  const load = async () => {
    try { const { data } = await api.get("/service-requests"); setOrders(data); }
    catch (e) { console.error("Failed to load concierge orders", e); }
  };
  useEffect(() => { load(); }, [refreshKey]);

  return (
    <div>
      <p className="text-[#4A534E] mb-6">Paid done-for-you setup orders. Click <b>Build listing</b> to pre-fill a Premium, owner-assigned facility from the order.</p>
      {orders.length === 0 ? (
        <div className="text-center py-20 bg-white rounded-2xl border border-[#E8E6DF] text-[#5C6660]" data-testid="orders-empty">No concierge orders yet.</div>
      ) : (
        <div className="space-y-3" data-testid="orders-list">
          {orders.map((o) => (
            <div key={o.request_id} className="bg-white border border-[#E8E6DF] rounded-2xl p-5">
              <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-xl bg-[#E3F3ED] flex items-center justify-center shrink-0"><ClipboardList className="h-5 w-5 text-[#0077B6]" /></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <span className="font-medium text-[#1C211F]">{o.facility_name || "Facility setup"}</span>
                    <span className={`text-xs font-semibold ${o.status === "fulfilled" ? "text-[#1A365D]" : "text-[#0077B6]"}`}>
                      ${o.amount} · {o.status === "fulfilled" ? "fulfilled" : "open"}
                    </span>
                  </div>
                  <div className="text-sm text-[#4A534E] mt-0.5">{o.contact_name} · {o.email} · {o.phone || "no phone"}</div>
                  {o.notes && <p className="text-sm text-[#2A312D] mt-2 bg-[#F7F6F2] rounded-xl p-3">{o.notes}</p>}
                  <div className="mt-3">
                    {o.status === "fulfilled" ? (
                      <span className="inline-flex items-center gap-1.5 text-sm text-[#1A365D]"><CheckCircle2 className="h-4 w-4" /> Listing built</span>
                    ) : (
                      <Button onClick={() => onBuild(o)} className="bg-[#1A365D] hover:bg-[#12283F] text-white rounded-xl" data-testid="build-listing-btn">
                        <Wand2 className="h-4 w-4 mr-1.5" /> Build listing
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
